<template>
  <div id="page-user-view">
    <h2 class="mb-5">{{$t('Tax Profiles')}}</h2>
    <shipblu-table
      :sst="true"
      pagination
      :max-items="maximumItems"
      :data="taxProfiles"
      :tableLoader="tableLoader"
      :hideHeader="true"
    >
      <template slot="thead">
        <shipblu-th>{{$t('Merchant Name')}}</shipblu-th>
        <shipblu-th>{{$t('Tax Type')}}</shipblu-th>
        <shipblu-th>{{$t('Legal Name')}}</shipblu-th>
        <shipblu-th>{{$t('Tax Registration Number')}}</shipblu-th>
        <shipblu-th>{{$t('Governorate')}}</shipblu-th>
        <shipblu-th>{{$t('City')}}</shipblu-th>
        <shipblu-th>{{$t('Street')}}</shipblu-th>
        <shipblu-th>{{$t('Building Number')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr class="inactive-link" :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <shipblu-td class="order-4" :data="data[indextr].merchant">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Merchant Name')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].merchant ? data[indextr].merchant.name : '' }}
            </p>
          </shipblu-td>
          
          <shipblu-td :data="data[indextr].number" class="sm:order-3 order-16">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Tax Type')}}</p>
              <p class="sm:text-base text-sm">
                <span>{{ data[indextr].company ? $t('Company') : data[indextr].person ? $t('Personal') : '' }}</span>
              </p>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].legal_name">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Legal Name')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].name ? data[indextr].name : '' }}
            </p>
          </shipblu-td>
          
          <shipblu-td class="order-6" :data="data[indextr].net_service_fees_due">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Tax Registration Number')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].person ? data[indextr].person.national_id : data[indextr].company ? data[indextr].company.tax_registration_number : '' }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].governorate">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Governorate')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].governorate ? data[indextr].governorate : '' }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].city">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('City')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].city ? data[indextr].city : '' }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].street">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Street')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].street ? data[indextr].street : '' }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-9" :data="data[indextr].building_number">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Building Number')}}</p>
            <p class="sm:text-base text-sm">
              {{ data[indextr].building_number ? data[indextr].building_number : '' }}
            </p>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" @changePageSize="changePageSize" />
  </div>
</template>

<script>
import {sendRequest} from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'

export default {
  data () {
    return {
      selected: [],
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      taxProfiles: [],
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      tableLoader: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.selected = []
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadTaxProfiles()
    }
  },
  methods: {
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.offset = 0
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.loadTaxProfiles()
    },
    loadTaxProfiles () {
      this.searchInProgress = true
      this.tableLoader = true
      const query = `offset=${this.offset}&limit=${this.maximumItems}`
      sendRequest(true, false, this, `api/v1/accounting/tax-profiles/?${query}`, 'get', null, true, 
        (response) => {
          this.taxProfiles = response.data.results
          this.tableLoader = false
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
          this.searchInProgress = false
        },
        () => {
          this.tableLoader = false
          this.searchInProgress = false
        }
      )
    }
  },
  components: { 
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.currentPage = this.$route.query.page ? Number(this.$route.query.page) : 1
    this.loadTaxProfiles()
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
</style>
